// right.js
import React, { Fragment, useEffect, useState, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Alert} from "../../shared";
import {
  setDashboardMine,
  setZoneWidgets,
  setDashboardZone,
  setDashboardDetails,
  setDeviceMine,
  setSelectedZone,
} from "../../redux";
import "./right.css";
import { MainPageDesktop } from "./desktopView/MainPageDesktop";
import { MainPageMobile } from "./mobileView/MainPageMobile";
import { ThemeToggle } from "./ThemeToggle";
import {
  getTodayDate,
  dashboardMine,
  zoneWidgets,
  dashboardZone,
  deviceMineApi,
} from "../../api";
import Cookies, { set } from "js-cookie";
import { Widgets, Device } from "../../shared/DeviceWidgets";
import { WidgetSkeloton } from "../../shared/SkelotonScreen";
import { makeId } from "../../components/helpers";
import Paho from "paho-mqtt";
import { withRouter } from "react-router-dom";
import { FiEyeOff, FiEye, FiHardDrive, FiServer } from "react-icons/fi";
import { MqttConnection } from "../MqttConnection";
import i18n from "../../i18n/locales/config";

var hostname = "assessn.mmaviot.com";
var port = 9999;
var user = "vertex";
var password = "TwZs5P4wJ6t85G8NtPQZ";
var topic_assess = "assess/device/";
var topic_control = "control/device/";
var reconnectTimeout = 1000;
var timeout = 1000;
const ERROR_HOST_DISCONNECTED = "connection lost";
const ERROR_HOST_UNREACHABLE = " connecting to server is impossible ";
const SUCCESS_HOST_CONNECTED = "connected to the server ";
const ALERT_HOST_CONNECTING = "connecting to server";
var clients = [];

const RightComp = (props) => {
  var connected = false;
  const { t } = useTranslation();
  const [isPhone, setIsPhone] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);
  const [viewIndex, setViewIndex] = useState(0);
  const dispatch = useDispatch();
  const [showDevicsSection, setShowDevicsSection] = useState(true);
  const [today, setToday] = useState("");
  const token = Cookies.get("token");
  const zoneWidget = useSelector((state) => state.zoneWidgets.zoneWidgets);
  const selectedZone = useSelector((state) => state.selectedZone);
  const dashboardZones = useSelector(
    (state) => state.dashboardZones.dashboardZones
  );
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  const deviceMine = useSelector((state) => state.deviceMine.deviceMine);
  const [health, setHealth] = useState({
    health: "",
    node: "",
    status: "",
  });
  let gadget2 = [];
  var i = 0;

  useEffect(() => {
    var width = Math.max(window.screen.width, window.innerWidth);
    if (width <= 992) {
      setIsPhone(true);
    }

    getTodayDate(token)
      .then((res) => {
        setToday(Date().slice(0, 11));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 5000);
        }
      });

    deviceMineApi(token)
      .then((res) => {
        const deviceData = res.data.data;
        dispatch(setDeviceMine(deviceData));
        var today = new Date();
        var time = today.getSeconds();
        deviceData.map((item, i) => {
          gadget2.push({
            id: item.id,
            active: true,
            time: time,
            widgets: null,
          });

          function connectDevice() {
            var client = new Paho.Client(hostname, Number(port), makeId(9));
            clients.push(client);
            client.onConnectionLost = onConnectionLost;
            client.onMessageArrived = onMessageArrived;
            client.connect({
              timeout: 3000,
              mqttVersion: 3,
              onSuccess: onSuccess,
              onFailure: onFailure,
              userName: item.user,
              password: item.password,
              useSSL: true,
              keepAliveInterval: 1000,
              reconnect: true,
            });

            function onSuccess() {
              connected = true;
              deviceData.map((v) => {
                setTimeout(() => {
                  if (!connected) {
                    console.log("Not connected to host: " + hostname);
                  } else {
                    client.subscribe(topic_assess + v.id);
                    client.subscribe(topic_control + v.id);
                  }
                }, timeout);
              });
            }

            function onFailure(e) {
              setShowAlert({
                show: true,
                message: t("عدم اتصال به سرور، لطفا اتصال خود را به اینترنت چک نموده و وی پی ان خود را خاموش نمایید، درصورتیکه مشکل برطرف نشد مرورگر خود را مجددا اجرا نمایید"),
                type: "Error",
              });
              console.log("Connection Lost ... ");
              setTimeout(connectDevice, 500);
            }
          }

          setTimeout(connectDevice, 500);
        });
      })
      .catch(() => {});

    dashboardMine(token)
      .then((res) => {
        dispatch(setDashboardMine(res.data.data));
        const formData = new FormData();
        formData.append("dashboard", res.data.data[0].id);
        dispatch(setDashboardDetails(res.data.data[0]));
        dashboardZone(formData, token)
          .then((res) => {
            dispatch(setSelectedZone(res.data.data[0].id));
            const zoneIdd = new FormData();
            zoneIdd.append("zone", res.data.data[0]["id"]);
            zoneWidgets(zoneIdd, token)
              .then((res) => {
                dispatch(setZoneWidgets(res.data.data));
              })
              .catch((err) => {
                setIsEmpty(true);
                if (err.response.status === 403) {
                  Cookies.remove("token");
                  props.history.push("/login");
                  setShowAlert((prevState) => ({
                    ...prevState,
                    show: true,
                    message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
                    type: "Error",
                  }));
                  setTimeout(() => {
                    setShowAlert((prevState) => ({
                      ...prevState,
                      show: false,
                    }));
                  }, 5000);
                }
              });
            dispatch(setDashboardZone(res.data.data));
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 5000);
        }
      });
  }, []);

  function onConnectionLost(responseObject) {
    connected = false;
  }

  function onMessageArrived(message) {
    var a = message.destinationName.split("/");
    if (a[0] == "assess") {
      var PowerManagementCalculator = message.payloadString.split(",");
      var PowerManagementCalculatorSplit =
        PowerManagementCalculator[2].split(":");
      analyzeMessageAssess(
        message.payloadString,
        a[2],
        PowerManagementCalculatorSplit[1]
      );
    }
  }

// در تابع analyzeMessageAssess، این بخش رو اصلاح کن:

// تابع برای تعیین رنگ بر اساس توان مصرفی
const getPowerColorClass = (power) => {
  if (power === null || power === undefined || isNaN(power)) {
    return "widget-power-unknown";
  }
  if (power < 100) {
    return "widget-power-low";     // سبز
  } else if (power >= 100 && power <= 500) {
    return "widget-power-medium";  // زرد
  } else {
    return "widget-power-high";    // قرمز
  }
};

function analyzeMessageAssess(message, node, energy) {
  var today = new Date();
  var time = today.getSeconds();
  var _m = JSON.parse(message);
  
  gadget2.map((item, i) => {
    if (item.id === node) {
      item.time = time;
      item.widgets = _m.y;
    }
  });
  
  _m.y.forEach(function (v, i) {
    var exhibit = v == 1 || v == 2 || v == 5 ? "device-on" : "device-off";
    var elem = document.getElementById(`${node}index${i}`);
    var text = document.getElementById(`${node}text${i}`);
    
    if (elem !== null) {
      // حذف کلاس‌های قبلی
      elem.classList.remove("device-on", "device-off", "widget-active");
      elem.classList.remove("widget-power-low", "widget-power-medium", "widget-power-high", "widget-power-unknown");
      
      if (exhibit === "device-off") {
        elem.classList.add("device-off");
        if (text) text.innerHTML = t("خاموش");
      } else if (exhibit === "device-on") {
        elem.classList.add("device-on");
        elem.classList.add("widget-active");
        
        if (!isNaN(energy) && energy !== undefined) {
          var power = Math.round(220 * energy);
          console.log("Power:", power, "Watts"); // برای دیباگ
          
          if (text && energy != "undefined") {
            text.style.fontSize = "11px";
            text.innerHTML = power + "W";
          }
          
          // اضافه کردن کلاس رنگ بر اساس مصرف
          if (power < 100) {
            elem.classList.add("widget-power-low");
            console.log("Added green class - low power"); // دیباگ
          } else if (power >= 100 && power <= 500) {
            elem.classList.add("widget-power-medium");
            console.log("Added yellow class - medium power"); // دیباگ
          } else {
            elem.classList.add("widget-power-high");
            console.log("Added red class - high power"); // دیباگ
          }
        } else {
          // اگر عدد نداشت، سبز پیش‌فرض
          elem.classList.add("widget-power-low");
          if (text) text.innerHTML = t("روشن");
          console.log("No power data, default green"); // دیباگ
        }
      }
    }
  });
  
  var span = document.getElementsByClassName(node);
  for (i = 0; i < span.length; i++) {
    span[i].classList.remove("dangerBorder");
    span[i].classList.add("successBorder");
  }
}

  const sendWidgetCommand = (command, id) => {
    var message = new Paho.Message(command);
    message.destinationName = topic_control + id;
    clients.map((client) => {
      client.send(message);
    });
  };

  const getDevices = () => {
    setViewIndex(2);
  };

setInterval(() => {
  var today = new Date();
  var time = today.getSeconds();
  gadget2.map((item) => {
    if (time - item.time > 6) {
      var span = document.getElementsByClassName(item.id);
      for (i = 0; i < span.length; i++) {
        span[i].classList.add("dangerBorder");
        span[i].classList.remove("successBorder");
      }

      item.widgets?.map((v, i) => {
        var elem = document.getElementById(`${item.id}index${i}`);
        var text = document.getElementById(`${item.id}text${i}`);

        if (elem !== null) {
          elem.classList.remove("device-on");
          elem.classList.add("device-off");
          elem.classList.remove("widget-active");
          // حذف کلاس‌های رنگ
          elem.classList.remove("widget-power-low", "widget-power-medium", "widget-power-high", "widget-power-unknown");
          if (text) {
            text.innerHTML = t("خاموش");
          }
        }
      });
    }
  });
}, 6000);

  const handleFa = () => {
    i18n.changeLanguage("fa");
  };

  // Shared nav buttons used in both desktop and mobile bottom sections
  const NavButtons = () => (
    <div className="d-flex gap-2">

      <i
        className={`d-block widgetDisplayIcons cursor
          d-flex align-items-center justify-content-center
          mx-1 rounded-circle phoneView
          ${viewIndex === 1 ? "bg-priimary text-white" : "bg-white"}`}
        onClick={() => setViewIndex(1)}
        title={t("مشاهده")}
        role="button"
        aria-label={t("مشاهده")}
      >
        {viewIndex === 1 ? <FiEye /> : <FiEyeOff />}
      </i>
      <i
        className={`d-block widgetDisplayIcons cursor
          d-flex align-items-center justify-content-center
          mx-1 rounded-circle phoneView
          ${viewIndex === 0 ? "bg-priimary text-white" : "bg-white"}`}
        onClick={() => setViewIndex(0)}
        title={t("ویجت ها")}
        role="button"
        aria-label={t("ویجت ها")}
      >
        <FiServer />
      </i>
    </div>
  );

  // Shared widgets/devices display used in both desktop and mobile bottom sections
  const WidgetsDisplay = () => (
    <>
      {viewIndex === 0 || viewIndex === 1 ? (
        <div
          className="text-right mt-3 p-1 d-flex flex-wrap"
          id="devices"
        >
          {zoneWidget?.length !== 0 ? (
            zoneWidget?.map((zone, index) => {
              if (viewIndex === 0 && zone.property[3] !== "0") {
                return (
                  <Widgets
                    key={index}
                    zone={zone}
                    health={health}
                    sendWidgetCommand={sendWidgetCommand}
                  />
                );
              } else if (viewIndex === 1) {
                return (
                  <Widgets
                    key={index}
                    zone={zone}
                    showAll={true}
                    health={health}
                    sendWidgetCommand={sendWidgetCommand}
                  />
                );
              }
            })
          ) : (
            <>
              {isEmpty && (
                <>
                  <WidgetSkeloton />
                  <WidgetSkeloton />
                  <WidgetSkeloton />
                  <WidgetSkeloton />
                </>
              )}
            </>
          )}
          {viewIndex === 2
            ? deviceMine?.map((device, index) => (
                <Device device={device} key={index} />
              ))
            : ""}
        </div>
      ) : (
        <div
          className="text-right mt-3 p-1 devices d-flex justify-content-around flex-wrap"
          id="devices"
        >
          {viewIndex === 2
            ? deviceMine?.map((device, index) => (
                <Device device={device} key={index} />
              ))
            : ""}
        </div>
      )}
    </>
  );

  // Shared zone info + nav header used in both desktop and mobile bottom sections
  const ZoneHeader = () => {
    // recalculate i inline for display
    let count = 0;
    zoneWidget?.forEach((item) => {
      if (viewIndex === 0 && item.property[3] !== "0") {
        count++;
      } else if (viewIndex === 1) {
        count = zoneWidget.length;
      } else if (viewIndex === 2) {
        count = deviceMine.length;
      }
    });

    return (
      <div className="w-100 px-3 my-2" style={{ height: "6vh" }}>
        <div className="d-flex align-items-center justify-content-between">
          <div className="text-right mt-2">
            <p className="m-0 fn14">
              {selectedZone.zone_caption
                ? selectedZone.zone_caption
                : dashboardZones && dashboardZones[0]["zone_caption"]}
            </p>
            <small style={{ fontSize: "12px" }}>
              {count} {viewIndex === 2 ? t("دستگاه") : t("ویجت")}
            </small>
          </div>
          <NavButtons />
        </div>
      </div>
    );
  };

  return (
    <div>
      {!isPhone && <ThemeToggle />}

      {!isPhone ? (
        <>
          <MainPageDesktop today={today}>
            {/* Bottom Section - Always visible on desktop */}
            <div className="orient">
              <div className="d-flex my-2">
                <ZoneHeader />
              </div>
              <WidgetsDisplay />
            </div>
          </MainPageDesktop>
        </>
      ) : (
        <>
          <MainPageMobile
            today={today}
            showDevicsSection={showDevicsSection}
            setShowDevicsSection={setShowDevicsSection}
          />

          {/* Bottom Section - Conditional on mobile */}
          {showDevicsSection && (
            <div className="orient">
              <div className="d-flex my-2">
                <ZoneHeader />
              </div>
              <WidgetsDisplay />
            </div>
          )}
        </>
      )}

      <div
        className="text-right mb-30 p-10 devices d-flex justify-content-around flex-wrap"
        style={{ position: 'absolute', zIndex: 1000, bottom: '30px' }}
      >
        {showAlert.show && (
          <Alert
            message={showAlert.message}
            type={showAlert.type}
          />
        )}
      </div>
    </div>
  );
};

const Right = withRouter(RightComp);

export { Right };
